import {assert} from 'Asserts';
import lazyInit from 'util/lazyInit';

import APIIDPrefixToTypename from '../../graphql-fragments/APIIDPrefixToTypename.json5';

export type ApiIdPrefixToTypenameMapping = Record<string, string>;

interface APIIDPrefixToTypename {
  mapping: Array<{
    apiIdPrefix: string;
    __typename: string;
  }>;
}

export const TYPENAME_MAPPING_FILENAME = 'APIIDPrefixToTypename.json5';

const productionGetPrefixToTypename = lazyInit(() => {
  const mapping = (APIIDPrefixToTypename as APIIDPrefixToTypename).mapping;
  const prefixToTypename: ApiIdPrefixToTypenameMapping = {};
  mapping.forEach(({apiIdPrefix, __typename}) => {
    prefixToTypename[apiIdPrefix] = __typename;
  });
  assert(
    Object.keys(prefixToTypename).length === mapping.length,
    `Duplicate API ID Prefix in ${TYPENAME_MAPPING_FILENAME}`
  );
  return prefixToTypename;
});

// eslint-disable-next-line import/no-mutable-exports
export let getPrefixToTypename = productionGetPrefixToTypename;

/** @package */
export function overridePrefixToTypenameForTests(extraForTests: ApiIdPrefixToTypenameMapping): void {
  getPrefixToTypename = () => ({...productionGetPrefixToTypename(), ...extraForTests});
}

/** @package */
export function restorePrefixToTypenameForTests(): void {
  getPrefixToTypename = productionGetPrefixToTypename;
}
